<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="APA">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="JANUARY 1: Awakening Gratitude">
<h1 class="chapter" id="pAUG"><a href="#/contents#AB_ch02" id="AB_cha02">JANUARY 1<br/><br/> <span class="chapter2">Awakening Gratitude</span></a></h1>
<blockquote>
<p class="ext" id="pAf4R"><em>Oh come, let us worship and bow down; let us kneel before the L<span class="smallcaps">ORD</span> our Maker.</em></p>
</blockquote>
<p class="right" id="pA4q">—Psalm 95:6</p>
<p class="noind" id="pAY8"><span class="dcap"><b>A</b></span> quick step to a thankful heart is to spend a few minutes worshiping God. Open your Bible and read aloud a favorite psalm, Philippians 2, or any favorite passage. Sing a classic hymn. Thank God for evidence of His presence.</p>
<p id="pAo_">Another idea: in your journal, share your reaction to Brother Lawrence’s thoughts on worship:</p>
<ul class="ula" id="AI_">
<li id="pA14">“To worship God in truth is to recognize Him for being who He is, and to recognize ourselves for what we are.”</li>
<li id="pAeV">“To worship God in truth is further to admit that we are entirely contrary to Him, and that He is willing to make us like Himself if we desire it.”</li>
<li id="pAob">“We must worship him . . . by a humble and true adoration of spirit in the depth and center of our souls.”</li>
</ul>
<p id="pAca">Brother Lawrence, a seventeenth-century monk, was the author of <em>The Practice of the Presence of God</em>, in which these and other thoughts about worship are found. The book’s very title seems synonymous with the psalmist’s call to worship the King. And spending time in worship awakens gratitude in our hearts.</p>
<p class="left1" id="pAiP"><em>Father, You alone are worthy of worship—and I praise You for helping me know that joyful truth!</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02.vue?321228c4